import React, { useRef, useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import Slider from 'react-slick';
import classNames from 'classnames';
import ArrowLeftIcon from 'mdi-react/ChevronLeftIcon';
import ArrowRightIcon from 'mdi-react/ChevronRightIcon';
// @ts-ignore
import InnerImageZoom from 'react-inner-image-zoom';
import 'react-inner-image-zoom/lib/InnerImageZoom/styles.min.css';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import SmallSpinner from 'modules/shared/SmallSpinner';
import { useDebounce, useImageOnLoad } from 'modules/shared/hooks';

import styles from './PhotoCarousel.module.scss';

type Props = {
  images: any[];
  index?: number;
  setIndex?: any;
  withControls?: boolean;
  openZoomHandler?: () => void;
  clearCanvas?: boolean;
};

const CarouselTv: React.FC<Props> = ({
  images,
  setIndex,
  index = 0,
  withControls = false,
  clearCanvas,
  openZoomHandler = () => null,
}) => {
  const slider = useRef<Slider>(null);
  const debIndex = useDebounce(index, 300);
  const loading = index !== debIndex;

  const [previews, setPreviews] = useState<{ imageUrl: string }[]>([]);

  const handlePrevSlide = () => {
    setIndex((prev: number) => (prev ? prev - 1 : 0));
  };
  const handleNextSlide = () => {
    const imgSize = previews.length;
    setIndex((prev: number) => (prev + 1 !== imgSize ? prev + 1 : prev));
  };

  const { handleImageOnLoad, css } = useImageOnLoad();

  useEffect(() => {
    // @ts-ignore
    slider?.current?.slickGoTo(debIndex);
  }, [debIndex, previews]);

  useEffect(() => {
    const windowUrl = window.URL || window.webkitURL;

    setPreviews(images.map((image) => ({ imageUrl: image?.imageUrl ?? windowUrl.createObjectURL(image?.imageFile) })));
  }, [images]);

  const settings = {
    dots: false,
    arrows: false,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 200,
    fade: true,
    swipe: false,
    easing: 'ease-in-out',
    centerMode: true,
    adaptiveHeight: true,
  };

  return (
    <>
      {/* @ts-ignore */}
      <Slider
        className={classNames(styles.carousel, styles.modalCarousel)}
        initialSlide={debIndex}
        ref={slider}
        {...settings}
      >
        {previews.map((img: any, idx: number) => (
          <div
            key={idx}
            className={classNames(styles.slide)}
            {...(!withControls && { onDoubleClick: openZoomHandler })}
          >
            {loading && <SmallSpinner className={withControls ? styles.loaderModal : styles.loaderSmall} />}
            {withControls ? (
              <div>
                {idx === debIndex ? (
                  <InnerImageZoom
                    src={img.imageUrl}
                    zoomSrc={img.imageUrl}
                    srcSet={img.imageUrl}
                    alt="Фото недоступне"
                    width={600}
                    id={`preview-${idx}`}
                    hideHint
                  />
                ) : null}
              </div>
            ) : (
              <div className="d-flex flex-shrink">
                <img
                  className={styles.img}
                  src={img.imageUrl}
                  id="preview"
                  alt="Фото недоступне"
                  onLoad={handleImageOnLoad}
                  style={{ ...css.fullSize }}
                />
              </div>
            )}
          </div>
        ))}
      </Slider>
      <div className={clearCanvas ? styles.numbersAbs : styles.numbers}>
        {previews.length > 1 && !clearCanvas ? (
          <div className="d-flex my-1 align-items-center">
            <Button
              className={classNames('border-0 p-1', styles.control, {
                [styles.controlDark]: withControls,
              })}
              variant="outline-light"
              onClick={handlePrevSlide}
            >
              <ArrowLeftIcon />
            </Button>
            <span className="px-1 text-dark">{`Фото ${index + 1} з ${previews.length}`}</span>
            <Button
              className={classNames('border-0 p-1', styles.control, {
                [styles.controlDark]: withControls,
              })}
              variant="outline-light"
              onClick={handleNextSlide}
            >
              <ArrowRightIcon />
            </Button>
          </div>
        ) : null}
        {previews.length === 1 && !clearCanvas ? <span className="my-2 py-1 text-dark">Фото 1 з 1</span> : null}
      </div>
    </>
  );
};

export default CarouselTv;
